module.exports = __webpack_public_path__ + "static/media/white-bell-icon.c94b2b62.svg";